import { FC, useState } from 'react';

import { PictureIcon } from '../../../assets';
import { cn } from '../../../lib';
import { Skeleton } from '../../skeleton';
import { IFlag } from './types';

export const Flag: FC<IFlag> = ({
  alpha2,
  FallbackIcon,
  className,
  fallbackClassName,
  imageClassName,
  isLoading,
}) => {
  const [isError, setIsError] = useState(false);

  const setErrorHandler = () => {
    setIsError(true);
  };

  if (isLoading) {
    return (
      <div className={className}>
        <Skeleton
          className={cn('h-full w-full rounded-full', fallbackClassName)}
        />
      </div>
    );
  }

  return (
    <div className={className}>
      {isError || !alpha2 ? (
        (FallbackIcon ?? (
          <PictureIcon className={cn('h-full w-full', fallbackClassName)} />
        ))
      ) : (
        <img
          src={`/assets/flags/${String(alpha2 ?? '')}.svg`}
          alt={String(alpha2 ?? '')}
          loading="lazy"
          onError={setErrorHandler}
          className={cn('h-full w-full', imageClassName)}
        />
      )}
    </div>
  );
};
